import { CircularProgress } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useInView } from "react-intersection-observer";

export default function InViewWrapper({ children, ...props }) {
  const [inViewState, setInViewState] = useState(false);
  const { ref, inView, entry } = useInView({
    /* Optional options */
    threshold: 0,
  });

  useEffect(() => {
    if (inView) {
      setInViewState(true);
    }
  }, [inView]);

  return (
    <div ref={ref}>
      {inViewState ? (
        children
      ) : (
        <div
          className={`w-screen h-[300px] flex items-center justify-center ${props.className}`}
        >
          <CircularProgress color="primary" />
        </div>
      )}
    </div>
  );
}
